import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pageLayoutReducer';
import { IPageLayoutState } from 'store/types/pageLayoutTypes';

const initialState: IPageLayoutState = {
  isHeaderVisible: true,
  isFooterVisible: true,
  isMobileSearchOpen: false,
  isInApp: false,
  isMenuVisible: false,
  currentTheme: null,
  menuNavigation: { calendar: null, navigation: null },
};

export const pageLayoutSlice = createSlice({
  name: 'pageLayout',
  initialState,
  reducers,
});

export const {
  setIsHeaderVisible,
  setIsFooterVisible,
  setIsMobileSearchOpen,
  setIsMenuVisible,
  setMultipleLayoutOptions,
  setToggleCurrentTheme,
  setMenuNavigation,
} = pageLayoutSlice.actions;
export default pageLayoutSlice.reducer;
